export type SortByType =
  | 'neueste-bestellungen'
  | 'älteste-bestellungen'
  | 'neueste-lieferung'
  | 'älteste-lieferung'
  | 'brutto-aufsteigend'
  | 'brutto-absteigend'
  | 'netto-aufsteigend'
  | 'netto-absteigend';

export const SORT_BY_TRACKING_MAP: Record<string, SortByType> = {
  '-create': 'neueste-bestellungen',
  create: 'älteste-bestellungen',
  '-delivery': 'neueste-lieferung',
  delivery: 'älteste-lieferung',
  '-gross': 'brutto-absteigend',
  gross: 'brutto-aufsteigend',
  '-net': 'netto-absteigend',
  net: 'netto-aufsteigend',
};
